import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BlobImage from 'components/blobImage';
import { Forms, Modal, SaveButton, SystemText } from 'e4shared';

import { setShowSuccess } from 'actions/ui';
import { loadActiveProfiles } from 'actions/profile';

export const ShareModal = props => {
    const dispatch = useDispatch();

    const [type, setType] = React.useState('public');
    const [private_Share_Ids, setPrivate] = React.useState([]);
    const [public_Share_Ids, setPublic] = React.useState([]);

    const profiles = useSelector(state => state.profile.activeProfiles) || [];

    React.useEffect(() => {
        setPrivate(props.task?.private_Share_Ids);
        setPublic(props.task?.public_Share_Ids);
    }, [props.task]);

    React.useEffect(() => {
        dispatch(loadActiveProfiles());
    }, []);

    const closeModal = () => {
        props.close && props.close();
    };

    const save = () => {
        props.onShare &&
            props.onShare(private_Share_Ids, public_Share_Ids, () => {
                dispatch(setShowSuccess(SystemText('Objective/Share/Success')));
                closeModal();
            });
    };

    const footer = (
        <div>
            <SaveButton
                data-testid="button-share"
                saving={props.saving}
                setSaving={props.setSaving}
                className="btn btn-success"
                onClick={save}
            >
                {SystemText('Objective/Share/Buttons/Share')}
            </SaveButton>
            <button data-testid="button-cancel" className="btn" onClick={closeModal}>
                {SystemText('Objective/Share/Buttons/Cancel')}
            </button>
        </div>
    );

    const privateList = private_Share_Ids ? private_Share_Ids : [];
    const publicList = public_Share_Ids ? public_Share_Ids : [];

    return (
        <Modal show={props.show} title={SystemText('Objective/Share/Title')} close={closeModal} footer={footer}>
            <div className="row">
                <div className="col-md-12 mb10">
                    <button
                        className={`mr5 btn ${type === 'private' ? 'btn-primary' : ''}`}
                        onClick={() => setType('private')}
                    >
                        {SystemText('Objective/Share/FullAccess')}
                    </button>
                    <button className={`btn ${type === 'public' ? 'btn-primary' : ''}`} onClick={() => setType('public')}>
                        {SystemText('Objective/Share/ObjectiveAccess')}
                    </button>
                </div>
                <div className="col-md-12 mb10 text-sm">
                    {type === 'private' ? (
                        <span>{SystemText('Objective/Share/FullAccess/Details')}</span>
                    ) : (
                        <span>{SystemText('Objective/Share/ObjectiveAccess/Details')}</span>
                    )}
                </div>
                <div className="col-md-12 mb10">
                    <div style={{ display: type === 'private' ? '' : 'none' }}>
                        <Forms.Person
                            onChange={private_Share_Ids => setPrivate(private_Share_Ids)}
                            value={privateList}
                            exclude={[props.task.owner_Id, props.task.profile_Id]}
                            loadProfiles={() => dispatch(loadActiveProfiles())}
                            profiles={profiles}
                            blobImage={props => <BlobImage {...props} />}
                        />
                    </div>
                    <div style={{ display: type === 'private' ? 'none' : '' }}>
                        <Forms.Person
                            onChange={ids => setPublic(ids.filter(f => !privateList.some(p => p === f)))}
                            value={[...publicList, ...privateList]}
                            exclude={[props.task?.owner_Id, props.task?.profile_Id]}
                            disabled={privateList}
                            disabledMessage={SystemText('Objective/Share/User/FullAccess')}
                            loadProfiles={() => dispatch(loadActiveProfiles())}
                            profiles={profiles}
                            blobImage={props => <BlobImage {...props} />}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ShareModal;
